/* eslint-disable no-unused-vars */
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { getUrl } from 'utils';
import {
  LocalizationLinkedList,
  PreviewApp,
  GeneralSettingsForm,
  Loader,
  ErrorComponent,
} from 'components';
import { publisherLocalizationPages } from 'constants';
import * as S from './GeneralSettingsPage.styled';
import { routes } from 'config';
import { isAdvertiserRole } from 'store/selectors';
import { manageAppsAPI } from 'services/manageApps.service';

const GeneralSettingsPage = () => {
  const { pba_id } = useParams();

  const {
    data: previewData,
    isSuccess,
    isError,
    isLoading,
    isFetching,
  } = manageAppsAPI.useFetchAppDataQuery(pba_id);
  const isAdvertiser = useSelector(isAdvertiserRole);
  const pages = useMemo(() => {
    return publisherLocalizationPages
      .map((page) => {
        return { ...page, link: getUrl(routes, page.url_id, pba_id) };
      })
      .filter((pageItem) => {
        if (isAdvertiser && pageItem.display) return pageItem;
        if (!isAdvertiser) return pageItem;
      });
  }, [isAdvertiser]);

  if (isError) return <ErrorComponent />;
  if (isLoading) return <Loader.Global delay={1} />;
  return (
    <>
      {previewData && (
        <S.Container>
          <h1>App Settings</h1>
          <S.Main>
            <S.Wrap>
              <S.ListPosition>
                <PreviewApp />
                <LocalizationLinkedList data={pages} show={true} />
              </S.ListPosition>
              <GeneralSettingsForm
                previewData={previewData}
                isFetching={isFetching}
                isLoading={isLoading}
              />
            </S.Wrap>
          </S.Main>
        </S.Container>
      )}
    </>
  );
};

export default GeneralSettingsPage;
